// Generated sandbox code: SSVMN - PlusTools - Editor v6.4.1 - 02/12/2020
// Created/Updated by Developer - 6/1/2021

import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { ADN_PLUS, CtFormComponent, CtRowComponent, HttpService } from 'components';
import { BaseController } from './base.controller';

@Component({
  selector: 'av-vi02',
  template: `<div [id]="getId()" #target><div>`
})

export class AvVi02 extends BaseController {

  numSolicitud;


  constructor(private routerParams: ActivatedRoute) {
    super();
    super.setViewCode('AV_VI02');
  }

  ngOnInit() {
    this.routerParams.queryParams.subscribe(params => {

      if (!params) return;

      const solRaw: string = Object.keys(params)[0];
      const numsol: string = atob(solRaw).split('+')[0];

      this.numSolicitud = numsol;
    });
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  getSolicInfo() {

    let contRequest = {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_SOL",
          "Alias": "NUM_SOL",
          "Value": this.numSolicitud,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }]
      },
      "Data": []
    }

    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_GET_SOL_EXTERNAL', contRequest)

  }

  showHideUpload(evt, res) {
    const CtRow = this.utilService.getComponentRef(evt.actionParams[0]) as CtRowComponent;
    let adn;

    if (res && res instanceof Array)
      adn = new ADN_PLUS(res[0])
    else
      adn = new ADN_PLUS(res)

    let state = adn.getStringAttribute('ESTADO_SOLIC');
    if (state == 'DP') {
      CtRow.setHidden(false);
    }

  }

  /* -------------------- END CONTROLLER LOGIC ----------------- */

}
